import './contact-form.scss';


const contactForm = () => { 
    var wpcf7Elm = document.querySelector( '.wpcf7' );
 
    wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
        const modalTarget = document.querySelector('.cf7-modal');
        modalTarget.classList.add('open');
        document.body.style.overflow = 'hidden';
    }, false );
}

export default contactForm;